var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sales-period-form',{attrs:{"project":_vm.project,"teams":_vm.teams,"errors":_vm.errors,"products":_vm.products,"loading":_vm.loading,"available-sales-managers":_vm.availableSalesManagers,"initial-selected-sales-manager":_vm.initialSelectedSalesManager},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }